/** CanvasLayer registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCanvasLayer } from './parser';
const canvasLayerRegistration = {
    typeName: 'CanvasLayer',
    parser: parseCanvasLayer,
};
nodeRegistry.register(canvasLayerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map